// extracted by mini-css-extract-plugin
export default {"ribbon":"HnxCE1","title":"rhJyRv","multiDayTitle":"Y1JXcC","fullDate":"ljI_gu","location":"OL_Op5","members":"tD9JLb","description":"LaNWRV","share":"X_qLUG","eventBadge":"h4meMC"};